import axios from "axios";

axios.defaults.baseURL = `/api`;
